import { memo, useState } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { TeleconsultoriaAgendasSection } from "../../schedule-manager/components/TeleconsultoriaAgendasSection";
import { useOrganizationProfessionalOptions } from "../hooks/useOrganizationProfessionalOptions";
import { ProfessionalFilterSelect } from "./ProfessionalFilterSelect";

/**
 * Visão CLÍNICA da prestadora — agendas de teleconsultoria por profissional (gestor).
 * Com um profissional escolhido: só as agendas dele e "Criar agenda" já para ele.
 * Em "Todos": todas as agendas; ao criar, o gestor escolhe o profissional no formulário.
 */
export const ClinicAgendasView = memo(function ClinicAgendasView() {
  const [professionalReference, setProfessionalReference] = useState("");
  const professionalOptions = useOrganizationProfessionalOptions();
  const selectedProfessional = professionalOptions.find(
    (option) => option.value === professionalReference,
  );

  return (
    <Stack spacing={2} width="100%">
      <Paper variant="outlined" sx={{ p: 1.5 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
        >
          <Typography variant="body2" color="text.secondary">
            Escolha um profissional para ver e criar as agendas dele.
          </Typography>
          <ProfessionalFilterSelect
            options={professionalOptions}
            value={professionalReference}
            onChange={setProfessionalReference}
          />
        </Stack>
      </Paper>
      <TeleconsultoriaAgendasSection
        title={
          selectedProfessional
            ? `Agendas de teleconsultoria · ${selectedProfessional.label}`
            : "Agendas de teleconsultoria da clínica"
        }
        practitionerReference={selectedProfessional?.value}
        showPractitioner={!selectedProfessional}
        createPresetProfessional={selectedProfessional}
      />
    </Stack>
  );
});
